export const formatTrendsDisplayDate = (isoDate: string): string => {
  const parsed = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return isoDate;
  }
  return parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getTrendsPeriodDateRangeLabel = (
  startDate: string,
  endDate: string,
): string => `${formatTrendsDisplayDate(startDate)} – ${formatTrendsDisplayDate(endDate)}`;

export const getTrendsPeriodDescription = (
  period: string,
  startDate: string,
  endDate: string,
): string => {
  const rangeLabel = getTrendsPeriodDateRangeLabel(startDate, endDate);

  switch (period) {
    case 'All':
      return `${rangeLabel} `;
    case 'YTD':
      return `${rangeLabel} · Year to date`;
    case '7D':
      return `${rangeLabel} · Last 7 days`;
    case '30D':
      return `${rangeLabel} · Last 30 days`;
    case '90D':
      return `${rangeLabel} · Last 90 days`;
    case 'Custom':
      return `${rangeLabel} · Custom range`;
    default:
      return rangeLabel;
  }
};

export const getTrendsPeriodButtonTitle = (
  period: string,
  startDate: string,
  endDate: string,
): string => {
  if (period === 'All') {
    return `All available revenue data: ${getTrendsPeriodDateRangeLabel(startDate, endDate)}. Does not include all-time sold ticket count.`;
  }
  return getTrendsPeriodDescription(period, startDate, endDate);
};

export const getTrendsMetricLabel = (
  metric: string,
  period: string,
  category: string,
): string => {
  const dashboardAlignedPeriod = period === 'All' || period === 'YTD';
  const isPeriodSoldMetric =
    metric === 'Sold' &&
    dashboardAlignedPeriod &&
    (category === 'All' || category === 'Financial' || category === 'Ticket Stats');

  if (isPeriodSoldMetric) {
    return 'Sold (in period)';
  }

  if (metric === 'Sold' && category === 'Status Breakdown') {
    return 'Sold (status)';
  }

  return metric;
};
